// extracted by mini-css-extract-plugin
export default {"container":"LeaderboradsSection_container__fheFr","wrapperCard":"LeaderboradsSection_wrapperCard__YXTyn"};